(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bars = document.querySelectorAll('.announcement-bar__track[data-rotate="true"]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    bars.forEach((track) => {
      const items = Array.from(track.children);
      if (items.length < 2 || reduce) return;

      const interval = Math.max(3, parseInt(track.dataset.interval || '5', 10)) * 1000;
      let current = 0;

      setInterval(() => {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, interval);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const form = document.getElementById('CollectionFilters');
    if (!form) return;

    let timer;
    const submit = () => form.submit();

    form.addEventListener('change', (e) => {
      if (e.target.matches('input[type="number"]')) return;
      submit();
    });
    form.addEventListener('input', (e) => {
      if (!e.target.matches('input[type="number"]')) return;
      clearTimeout(timer);
      timer = setTimeout(submit, 700);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Keep the sticky header positioned just below the announcement bar,
    // whatever its height turns out to be (it can wrap, or be absent), and
    // keep in-page anchor jumps (skip link, "#about", etc.) landing below
    // both sticky bars instead of underneath them.
    const root = document.documentElement;
    const bar = document.querySelector('.announcement-bar');
    const header = document.querySelector('.header');

    const setStickyOffsets = () => {
      const barHeight = bar ? bar.offsetHeight : 0;
      root.style.setProperty('--announcement-height', barHeight + 'px');
      root.style.setProperty('--sticky-offset', barHeight + (header ? header.offsetHeight : 0) + 'px');
    };
    setStickyOffsets();
    window.addEventListener('resize', setStickyOffsets);
    window.addEventListener('load', setStickyOffsets);

    // Reveal a subtle border/shadow on the sticky header once the page scrolls.
    if (header) {
      const updateStuck = () => header.classList.toggle('is-stuck', window.scrollY > 4);
      updateStuck();
      window.addEventListener('scroll', updateStuck, { passive: true });
    }

    const drawer = document.getElementById('header-drawer');
    if (drawer) {
      drawer.querySelectorAll('[data-close-drawer]').forEach((btn) => {
        btn.addEventListener('click', () => drawer.removeAttribute('open'));
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.hasAttribute('open')) drawer.removeAttribute('open');
      });
      window.matchMedia('(min-width: 990px)').addEventListener('change', (e) => {
        if (e.matches) drawer.removeAttribute('open');
      });
    }

    // Close open disclosures (dropdowns / search) when clicking outside or pressing Escape.
    const disclosures = document.querySelectorAll('.header__disclosure, .header__search');
    document.addEventListener('click', (e) => {
      disclosures.forEach((d) => {
        if (d.hasAttribute('open') && !d.contains(e.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      disclosures.forEach((d) => d.removeAttribute('open'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.product[data-section-id]').forEach((root) => {
      const sectionId = root.dataset.sectionId;

      /* Gallery */
      const mainItems = root.querySelectorAll('.product__media-item');
      const thumbs = root.querySelectorAll('.product__thumb');
      const normalizeId = (value) => String(value || '').split('/').pop();
      const showMedia = (mediaId) => {
        const id = normalizeId(mediaId);
        mainItems.forEach((item) => item.classList.toggle('is-active', !item.hidden && normalizeId(item.dataset.mediaId) === id));
        thumbs.forEach((t) => t.classList.toggle('is-active', !t.closest('li')?.hidden && normalizeId(t.dataset.thumbFor) === id));
      };
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => showMedia(thumb.dataset.thumbFor));
      });

      const galleryMapNode = document.querySelector('[data-variant-media-map="' + sectionId + '"]');
      let galleryMap = null;
      try {
        galleryMap = galleryMapNode ? JSON.parse(galleryMapNode.textContent) : null;
      } catch (e) {
        galleryMap = null;
      }
      const availableMedia = new Set(Array.from(mainItems, (item) => normalizeId(item.dataset.mediaId)));
      const revealFullGallery = () => {
        mainItems.forEach((item) => { item.hidden = false; });
        thumbs.forEach((thumb) => { if (thumb.closest('li')) thumb.closest('li').hidden = false; });
      };
      const filterGallery = (variant) => {
        const mapped = galleryMap && galleryMap[normalizeId(variant && variant.id)];
        const ids = Array.isArray(mapped) ? mapped.map(normalizeId) : [];
        const unique = new Set(ids);
        const heroId = normalizeId(variant && variant.featured_media && variant.featured_media.id);
        if (!ids.length || unique.size !== ids.length || ids.some((id) => !availableMedia.has(id)) || ids[0] !== heroId) {
          revealFullGallery();
          return false;
        }
        mainItems.forEach((item) => { item.hidden = !unique.has(normalizeId(item.dataset.mediaId)); });
        thumbs.forEach((thumb) => {
          const item = thumb.closest('li');
          if (item) item.hidden = !unique.has(normalizeId(thumb.dataset.thumbFor));
        });
        showMedia(ids[0]);
        return true;
      };

      /* Quantity stepper */
      const qtyInput = root.querySelector('.product-form__qty-input');
      if (qtyInput) {
        root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        });
        root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        });
      }

      /* Variant selection */
      const variantData = document.querySelector('[data-product-variants="' + sectionId + '"]');
      if (!variantData) return;

      let variants = [];
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (e) {
        return;
      }

      const optionSelects = Array.from(root.querySelectorAll('.product-form__option-select'));
      if (optionSelects.length === 0) return;
      const variantIdInput = root.querySelector('.product-form__variant-id');
      const submitButton = root.querySelector('.product-form__submit');
      const submitText = root.querySelector('.product-form__submit-text');
      const priceAmount = root.querySelector('.product__price .price__amount');
      const moneyFormat = (cents) => {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
          }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2);
        }
      };

      const strings = {
        add: submitButton ? submitButton.dataset.addLabel : 'Add to cart',
        soldOut: submitButton ? submitButton.dataset.soldOut : 'Sold out',
        unavailable: submitButton ? submitButton.dataset.unavailable : 'Unavailable'
      };

      const updateSelection = ({ writeHistory = true } = {}) => {
        const chosen = optionSelects.map((s) => s.value);
        const match = variants.find((v) => chosen.every((val, i) => v.options[i] === val));

        if (!match) {
          if (variantIdInput) variantIdInput.value = '';
          if (submitButton) submitButton.disabled = true;
          if (submitText) submitText.textContent = strings.unavailable;
          return;
        }

        if (variantIdInput) {
          variantIdInput.value = match.id;
          variantIdInput.disabled = false;
        }
        if (submitButton) submitButton.disabled = !match.available;
        if (submitText) submitText.textContent = match.available ? strings.add : strings.soldOut;
        if (priceAmount && typeof match.price === 'number') priceAmount.textContent = moneyFormat(match.price);
        const filtered = filterGallery(match);
        if (!filtered && match.featured_media && match.featured_media.id) showMedia(match.featured_media.id);

        if (writeHistory) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.pushState({}, '', url);
        }
      };

      optionSelects.forEach((select) => select.addEventListener('change', updateSelection));
      window.addEventListener('popstate', () => {
        const requestedId = new URL(window.location.href).searchParams.get('variant');
        const requested = variants.find((variant) => String(variant.id) === String(requestedId));
        if (requested) optionSelects.forEach((select, index) => { select.value = requested.options[index]; });
        updateSelection({ writeHistory: false });
      });
      updateSelection({ writeHistory: false });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-recommendations]').forEach((container) => {
      const url = container.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const fresh = html.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            container.innerHTML = fresh.innerHTML;
          }
        })
        .catch(() => {
          /* keep the server-rendered fallback */
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
